import { render, staticRenderFns } from "./Lance.vue?vue&type=template&id=023dbf26&scoped=true"
import script from "./Lance.vue?vue&type=script&lang=js"
export * from "./Lance.vue?vue&type=script&lang=js"
import style0 from "./Lance.vue?vue&type=style&index=0&id=023dbf26&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023dbf26",
  null
  
)

export default component.exports